import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import {TrendsComparisonService} from "../../../services/trendsComparisonService";
import {DICTIONARY} from "../../../dictionary";

@Component({
	selector: 'period-comparison-picker-c',
	templateUrl: './period-comparison-picker.component.html',
})
export class PeriodComparisonPickerComponent implements OnInit {
	dic = DICTIONARY;

	@Output() onConfirm = new EventEmitter();

	granularityOptions = ['Monthly', 'Weekly', 'Daily'];
	forwardDisabled = false;

	constructor(public comparisonService: TrendsComparisonService) {
	}

	ngOnInit() {
		this.updateForwardDisabled();
	}

	onGranularityChange(item) {
		this.comparisonService.granularity = item.toLowerCase();
		this.comparisonService.setDefaultDates(this.comparisonService.granularity);
		this.updateForwardDisabled();
	}

	onCurrentDateChange(date) {
		this.comparisonService.currentPeriodDate = date;
		this.updateForwardDisabled();
	}

	onComparedDateChange(date) {
		this.comparisonService.comparedPeriodDate = date;
		this.updateForwardDisabled();
	}

	confirmComparison() {
		this.comparisonService.activateComparison();
		this.onConfirm.emit();
	}

	private isAtOrAfterToday(date) {
		const todayStart = this.comparisonService.getDateRange(new Date(), this.comparisonService.granularity).start;
		const dateStart = this.comparisonService.getDateRange(date, this.comparisonService.granularity).start;
		return dateStart >= todayStart;
	}

	private updateForwardDisabled() {
		this.forwardDisabled = this.isAtOrAfterToday(this.comparisonService.currentPeriodDate) ||
			this.isAtOrAfterToday(this.comparisonService.comparedPeriodDate);
	}

	// shifts both dates by one granularity unit in the given direction (+1 forward, -1 backward)
	shiftBothPeriods(direction) {
		const shiftDate = (date) => {
			const d = new Date(date);
			if (this.comparisonService.granularity === 'monthly') {
				d.setMonth(d.getMonth() + direction);
			}
			else if (this.comparisonService.granularity === 'weekly') {
				d.setDate(d.getDate() + direction * 7);
			}
			else {
				d.setDate(d.getDate() + direction);
			}
			return d;
		};
		this.comparisonService.currentPeriodDate = shiftDate(this.comparisonService.currentPeriodDate);
		this.comparisonService.comparedPeriodDate = shiftDate(this.comparisonService.comparedPeriodDate);
		this.updateForwardDisabled();
	}
}
